import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  CountriesResponse,
  CountryResponse,
  CreateCountryRequest,
  UpdateCountryRequest,
} from "./types";

export const adminCountryApi = createApi({
  reducerPath: "adminCountryApi",
  baseQuery: baseApiQuery,
  tagTypes: ["Countries"],
  endpoints: (builder) => ({
    getCountries: builder.query<CountriesResponse, void>({
      query: () => "/admin/countries",
      providesTags: ["Countries"],
    }),

    createCountry: builder.mutation<CountryResponse, CreateCountryRequest>({
      query: (body) => ({
        url: "/admin/countries",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Countries"],
    }),

    updateCountry: builder.mutation<
      CountryResponse,
      { id: number; body: UpdateCountryRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/countries/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Countries"],
    }),

    deleteCountry: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/countries/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Countries"],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useCreateCountryMutation,
  useUpdateCountryMutation,
  useDeleteCountryMutation,
} = adminCountryApi;
